import {fromJS} from "immutable";
import React from "react";
import {connect} from "react-redux";
import {requestOrderDetail} from "../../../actions/InventoryApiActions";
import AddressInline from "../../../components/AddressInline";
import {pluralizeWithPrefix} from "../../../lib/TextFormatter";
import styles from "./OrderBasicInfo.module.scss";

const OrderBasicInfo = (props) => {
  const {
    warehouseId,
    className, name,
    address, withAddress,
    jobId, orgOrderId = null, packages,
    compact = true,
    noPadding,
    orderDetail = false,
  } = props;

  // filter on order number, name and pickup date
  const nbPackages = packages && (packages.length || packages.size);

  const classes = [
    styles.module,
    withAddress ? styles.withAddress : null,
    className,
    noPadding ? styles.noPadding : null,
    compact ? styles.compact : null,
  ];
  
  let addressElem = null;
  if (withAddress && address) {
    addressElem = (
      <div className={styles.address}>
        <AddressInline address={fromJS(address)} />
      </div>
    );
  }

  const idInfo = orderDetail
    ? <><div>Job Id: {jobId}</div>{orgOrderId ? <div>Order Id: {orgOrderId}</div> : null}</>
    : <a href="#" onClick={() => props.requestOrderDetail(warehouseId, jobId)} className={styles.jobId}>{ jobId }</a>;

  const nbPackagesElem = nbPackages && <span className={orderDetail ? styles.noMargin : null}>{ pluralizeWithPrefix(nbPackages, "Package", "Packages") }</span>

  return (
    <div className={classes.join(" ")}>
      <h2>{ name }</h2>
      { addressElem }
      <div>
        { idInfo }
        { nbPackagesElem }{ firstTagOnly(props.tags) }
      </div>
    </div>
  );
}

function firstTagOnly(tags) {
  // No space for more tags
  return tags && tags[0] && <span className={styles.tags}>{ tags[0] }</span>;
}

export default connect(null, {requestOrderDetail})(OrderBasicInfo);